import React, { useRef, useState } from "react";
import Draggable from "react-draggable";

const Text = () => {
  const nodeRef = useRef(null);
  const [editMode, setEditMode] = useState(false);
  const [val, setVal] = useState("Double click to edit");
  const [color, setColor] = useState("#ffffff");

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      setEditMode(false);
    }
  };

  return (
    <Draggable nodeRef={nodeRef}>
      <div ref={nodeRef} style={{ position: "absolute", cursor: "move" }}>
        {editMode ? (
          <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
            <input
              value={val}
              onChange={(e) => setVal(e.target.value)}
              onKeyDown={handleKeyDown}
              autoFocus
              className="form-control"
            />
            <input
              type="color"
              value={color}
              onChange={(e) => setColor(e.target.value)}
              title="Pick text color"
            />
          </div>
        ) : (
          <h1
            onDoubleClick={() => setEditMode(true)}
            style={{
              color: color,
              fontSize: "1.8rem",
              fontWeight: "bold",
              textShadow: "2px 2px 5px black",
              textAlign: "center",
            }}
          >
            {val}
          </h1>
        )}
      </div>
    </Draggable>
  );
};

export default Text;
